/**
 * @param {*} dateString 
 * @returns Valid Date object or null
 */
export const parseDate = (dateString) => {
  if (!dateString) return null;
  const parsedDate = new Date(dateString);
  return isNaN(parsedDate) ? null : parsedDate;
}

/**
 * @param {*} date 
 * @returns Date into long format: June 16
 */
export const longFormatDate = (date) => {
  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
}

/**
 * @param {*} startDate 
 * @param {*} endDate 
 * @returns Then number of weeks between the 2 given dates
 */
export const calculateWeeksBetween = (startDate, endDate) => {
  const daysBetween = (startDate - endDate) / (1000 * 60 * 60 * 24);
  return Math.round(Math.abs(daysBetween) / 7);
}
